import { useState } from "react";
import { Button } from "../ui/button.jsx";
import { Card } from "../ui/card.jsx";
import { pingSocket, useSocketStatus } from "../../lib/socket-client.js";
import { cn } from "../../lib/utils.js";

export default function SocketDiagnostics({ className }) {
  const status = useSocketStatus();
  const [checking, setChecking] = useState(false);
  const [result, setResult] = useState(null);

  const runPing = async () => {
    setChecking(true);
    try {
      const info = await pingSocket();
      setResult({ ok: true, latency: info.latency });
    } catch (error) {
      setResult({ ok: false, message: error.message });
    } finally {
      setChecking(false);
    }
  };

  return (
    <Card className={cn("rounded-3xl border-border bg-muted/20 p-4 text-xs text-muted-foreground", className)}>
      <div className="flex items-center justify-between">
        <div>
          <div className="text-sm font-semibold text-foreground">Socket health</div>
          <div className="mt-1">{status.connected ? "Connected" : status.connecting ? "Connecting…" : "Disconnected"}</div>
          {status.lastEvent && <div className="mt-0.5 text-[11px] text-muted-foreground">Event: {status.lastEvent}</div>}
          {status.latency != null && <div className="mt-0.5 text-[11px] text-muted-foreground">Latency: {status.latency}ms</div>}
          {status.error && <div className="mt-0.5 text-[11px] text-destructive">{status.error}</div>}
          {result && (
            <div className={cn("mt-0.5 text-[11px]", result.ok ? "text-emerald-500" : "text-destructive")}
            >
              {result.ok ? `Last ping ${result.latency}ms` : `Ping failed: ${result.message}`}
            </div>
          )}
        </div>
        <Button type="button" size="sm" variant="outline" onClick={runPing} disabled={checking}>
          {checking ? "Pinging…" : "Ping"}
        </Button>
      </div>
    </Card>
  );
}
